<script lang="ts" setup>
  import { userAction } from '../../../../shared/observability/userAction.ts';
  import { Button } from '../../../../shared/ui/button';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import { HostErrorCode } from '../../model/hostErrorCode.ts';
  import SongstarLogoHeader from '../SongstarLogoHeader.vue';
  import InactiveDeviceErrorMessage from './error-messages/InactiveDeviceErrorMessage.vue';
  import NotAllowedHostErrorMessage from './error-messages/NotAllowedHostErrorMessage.vue';
  import PremiumRequiredErrorMessage from './error-messages/PremiumRequiredErrorMessage.vue';
  import RestrictedDeviceErrorMessage from './error-messages/RestrictedDeviceErrorMessage.vue';
  import UnknownErrorMessage from './error-messages/UnknownErrorMessage.vue';

  defineProps<{ code: HostErrorCode }>();
  defineEmits<{ signIn: [] }>();

  const messageComponents = {
    [HostErrorCode.NotRegistered]: NotAllowedHostErrorMessage,
    [HostErrorCode.InactiveDevice]: InactiveDeviceErrorMessage,
    [HostErrorCode.PremiumRequired]: PremiumRequiredErrorMessage,
    [HostErrorCode.RestrictedDevice]: RestrictedDeviceErrorMessage,
    [HostErrorCode.Unknown]: UnknownErrorMessage,
  };
</script>

<template>
  <MobileViewLayout class="host-error">
    <template #header>
      <SongstarLogoHeader />
    </template>

    <component :is="messageComponents[code]" />

    <template #footer>
      <Button
        :data-faro-user-action-name="userAction.hostErrorSignInAgain"
        appearance="outline"
        @click="$emit('signIn')"
      >
        sign in again
      </Button>
    </template>
  </MobileViewLayout>
</template>

<style scoped>
  .host-error {
    --view-padding: 1.5rem var(--view-gutter) 0;
  }
</style>
